import axios from "axios";
import { ProtectionZoneSummaryResponse } from "../../../types/model/protectionZone";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const getProtectionZoneSummary = async (
  entityId?: number,
  managementUnitId?: number,
): Promise<ProtectionZoneSummaryResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const params: Record<string, number> = {};
  if (entityId && !managementUnitId) params.entityId = entityId;
  if (managementUnitId && !entityId) params.managementUnitId = managementUnitId;

  const res = await axios.get<ProtectionZoneSummaryResponse>(
    `${BASE_URL}/protection-zone/summary`,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      params,
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
